var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { agreementsCommon, baseCommon, configCommon, merchantCommon, } from '@repo/api/endpoints/merchant/msw/mocks/common';
export var WIDGET_LOADING = __assign(__assign({}, baseCommon), { type: 'IFRAME_MERCHANT_SUMMARY', currentProvider: ['test-provider'], data: {
        merchantData: __assign(__assign({}, merchantCommon), { user: {
                type: 'limit',
                userId: 12345,
                permission: {
                    widget: true,
                    newLoan: false,
                    cancelLoan: true,
                    continueLoan: false,
                },
                accessFor: ['193421', '1234', '4321'],
            } }),
        preLimits: [],
        limits: [],
        loans: [],
        agreements: agreementsCommon,
        transfers: [],
        offers: [],
    }, config: configCommon });
